<div class="loginDeck">
    <div class="leftBox"></div>
    <div class="rightBox"></div>
    <div class="loginForm">
      <div class="innerLoginDeck mar0">
        <div class="leftLoginDeck pad20">
          <div class="logoDeck  align-center">
            <!-- <img src="{{loginPathInfo?.logoPath}}" alt="" /> -->
                         <img src="https://chappsstorage.s3.ap-south-1.amazonaws.com/profilepicturesprod/ProfilePic/2023/JULY/20/callhealth-logo.svg" alt="callhealth" class="logoImage"/> 

           </div>
           <h4 class="welcomeTxt  align-center" >Welcome Back</h4>
           <p class="logintoCont" >Login to continue</p>
          <div class="loginFormContainer">
            <form [formGroup]="login_Form">
            <div class="form-group loginFormGrp" >
              <label for="">User ID</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="User ID"
                formControlName="name" (keyup)="autoSubmit($event)">
              <div class="text-danger errormsg" *ngIf="(f['name'].touched || isSubmited ) && f['name'].errors" >
                <div *ngIf="f['name'].errors['required']">User ID is required</div>
              </div>
           </div>
            <div class="form-group loginFormGrp" >
              <label for="exampleInputPassword1">Password</label>
              <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"
                formControlName="password" (keyup)="autoSubmit($event)">
              <div class="text-danger errormsg"*ngIf="(f['password'].touched || isSubmited ) && f['password'].errors" >
                <div *ngIf="f['password'].errors['required']">Password is required</div>
            </div>
            </div>          

            <button type="button" class="btn fullWidthBtn marTp-10 blueBtn" (click)="login()" >Submit</button>

           </form>
          </div>
        </div>

        <!-- <div class="rightLoginDeck">

          <img src="assets/images/login.png" />

        </div> -->

      </div>   
    </div>
  </div>